import React from 'react';
import styles from './Spinner.module.css';

const spinner = () => (
    <div className={styles.container}>
        <div className={styles.loader} />
    </div>
);

export default spinner;